import React, { Component, Fragment} from "react";
import { ElementsConsumer, CardElement, useStripe, PaymentRequestButtonElement } from "@stripe/react-stripe-js";

import { loadStripe } from '@stripe/stripe-js/pure';

import { CountryDropdown, RegionDropdown } from 'react-country-region-selector';
import Select from "react-select";
import Card from "./Card";
import { getCheckoutStepsData } from "../../../services/user";
import { CheckoutForm } from "../../../services/stripe";
import { processPayment, setCustomerSubscription } from "../../../services/checkout";
import AppContext from "../../../contexts/AppContext";
import InjectGooglePay from "../../payment/GooglePaySubscription";

import {PayPalBtn}   from "../../PayPal/subscription/PayPalBtn";



class StripeCheckoutForm extends Component {

    state = {
        item: {
            fname: this.context.state.user.first_name,
            lname: this.context.state.user.last_name,
            cardholdername: this.context.state.user.first_name +' '+ this.context.state.user.last_name,
			email: localStorage.getItem('user_email') !== null || localStorage.getItem('user_email') !== undefined ? localStorage.getItem('user_email') : '',
			address: '',
			city: '',
			province: '',
			zip: '',
			country: '',
            how_did_you_find_us: null,
            step: 'final',
            token_type: 'pwonbs1',
            card: '',
            how_did_you_find_us: null,
            selectedItem: 'Select',
            province_option_label: '',
            paymentMethodDetails: '',
            stripe: '',
            payment_method_details: 'card-checkout',
            payment_gateway:'',
            subscriptionID:'',
            agree:''
        },
		errors: {},
		loading: false,
		cardData : '',
        how_did_you_find_us_options: [],
        paymentIntentDetails: '',
        subscriptionDetails: '',
        paymentMethodId: '',
        cardDetails: '',
        confirmCardSetupResult: '',
        showCheckoutButton: true,
        isFormFilled:  false,
        is_paypal:false,
        paypal_loading:false,
        paypal_annual_plan_id:''
	};
    selectCountry = val => {
		let temp = this.state.item;
        temp['country'] = val;
		let error = this.state.errors;
        error['country'] = null;

        if (val == 'Canada') {
            temp['province_option_label'] = 'Select Province';
        } else if (val == 'United States') {
            temp['province_option_label'] = 'Select State';
        }
        this.setState({ item: temp, errors: error });
	}

	selectRegion = val => {
		let temp = this.state.item;
        temp['province'] = val;
		let error = this.state.errors;
        error['province'] = null;
        this.setState({ item: temp, errors: error });
	}
    onChange = field => {
        let temp = this.state.item;
        temp[field.target.name] = field.target.value;
        let error = this.state.errors;
        error[field.target.name] = null;
        this.setState({ item: temp, errors: error });
	}

    onCardChange = () => {
        this.handleStripeCardSubmit();
    }


    handleHowDidYouFindUsSelectChange = selectedOption => {
        let temp = this.state.item;
        temp.how_did_you_find_us = selectedOption.value;
        temp.selectedItem = selectedOption.name;
        let error = this.state.errors;
        error.how_did_you_find_us = null;
        this.setState({ item: temp, errors: error });
    }

    handleCheckboxChange = () => {
		let temp = this.state.item;
		temp['agree'] = !temp.agree;
		let error = this.state.errors;
		error['agree'] = !temp.agree ? "Please agree to our terms and conditions." : null;
		this.setState({ item: temp, errors: error });

        if (this.state.item.card) {
            this.setState({ isFormFilled: true })
        }

	}

    handleStripeCardSubmit = async event => {
        let temp = this.state.item;
        let errors = {};
        const { stripe, elements } = this.props;


        if (!stripe || !elements) {

            console.log('not found stripe');
            return;
        }
        const card = elements.getElement(CardElement);
        const result = await stripe.createToken(card);
        if (result.error) {
            errors.card = result.error.message;
            this.setState({ errors: errors });
            temp['card'] = null;
        }
        else
        {
		    temp['card'] = result.token;
        }

        /*create payment method for 3DS authentication */
        const paymentMethodData = await stripe.createPaymentMethod({
            type: 'card',
            card: card,
        });

        if (paymentMethodData.error) {
            this.setState({ errors: errors });
            temp['paymentMethodDetails'] = null;
        }
        else {
            temp['paymentMethodDetails'] = paymentMethodData.paymentMethod;
        }
        temp['stripe'] = stripe;

        this.setState({ cardDetails: card });
        if (this.state.item.agree) {
            this.setState({ isFormFilled: true })
        }
    }

    handleValidation = () => {
        let fields = this.state.item;
        let errors = {};
        let formIsValid = true;

        if(!fields.fname){
            formIsValid = false;
            errors.fname = "The first name field is required.";
		}
		if(!fields.lname){
            formIsValid = false;
            errors.lname = "The last name field is required.";
		}
        if (!fields.cardholdername) {
            formIsValid = false;
            errors.fname = "The cardholder name field is required.";
        }
		if (!fields.email) {
            formIsValid = false;
            errors.email = "The email field is required.";
		}
		/*if (!fields.address) {
            formIsValid = false;
            errors.address = "The address field is required.";
		}
		if (!fields.city) {
            formIsValid = false;
            errors.city = "The city field is required.";
		}
		if (!fields.province) {
            formIsValid = false;
            errors.province ="The state field is required.";
		}
		if (!fields.zip) {
            formIsValid = false;
            errors.zip = "The zip field is required.";
		}
		if (!fields.country) {
            formIsValid = false;
            errors.country = "The country field is required.";
		} */

        if (!fields.paymentMethodDetails) {
            formIsValid = false;
            errors.country = "The payment method field is required.";
        }

        if ((fields.paymentMethodDetails == 'card-checkout' && !fields.card) || (fields.paymentMethodDetails == '' && !fields.card)) {
            errors.card ="Your card number is incomplete.";
            formIsValid = false;
        }

		if (!fields.agree) {
            formIsValid = false;
            errors.agree = "Please agree to our terms and conditions.";
        }

        this.setState({ errors: errors });
        return formIsValid;
    }


    handlePaymentMethodDetailsChange = selectedOption => {
        let value = selectedOption.target.value;

        if (value == 'card-checkout' || value == '') {
            this.setState({ showCheckoutButton: true });
            this.setState({ is_paypal: false });
        }else if (value == 'paypal-checkout' || value == '') {
            this.setState({ showCheckoutButton: false });
            this.setState({ is_paypal: true });
        }else {
            this.setState({ showCheckoutButton: false });
            this.setState({ is_paypal: false });
        }

        let temp = this.state.item;
        temp.payment_method_details = value;
        let error = this.state.errors;
        error.payment_method_details = null;
        this.setState({ item: temp, errors: error });
    }

    handleSubmit = async event => {
        event.preventDefault();
        let stripe = this.state.item.stripe;
        this.setState({ submitCalled: true})
        if(this.handleValidation())
		{
			this.setState({loading: true});
			processPayment(this.state.item)
            .then(res => {

                /*confirm card set up for 3DS authentication*/
                stripe.confirmCardSetup(
                    res.data.setUpIntentDetails.client_secret,
                    {
                        payment_method: {
                            card: this.state.cardDetails,
                            billing_details: {
                                name: this.state.item.fname + ' ' + this.state.item.lname,
                            },
                        },
                    }
                ).then((confirmCardSetupResult) => {
                    if (confirmCardSetupResult.error) {
                        this.setState({ loading: false });
                        this.context.state.showCodeMessage(confirmCardSetupResult.error.message, 'danger');
                    } else {

                        if (confirmCardSetupResult.setupIntent.status == 'succeeded') {
                            this.setState({ confirmCardSetupResult: confirmCardSetupResult });
                            this.setState({ cardDetails: '' });

                            /*assigning the newly created payment method to customer and create subscription */
                            setCustomerSubscription(this.state).then(setupIntentResult => {
                                console.log(setupIntentResult);
                                if(setupIntentResult.status ==  200) {
                                    this.context.state.showCodeMessage(setupIntentResult.data.message, 'success');
                                    localStorage.setItem('user_steps', 'account');
                                    localStorage.setItem("user", JSON.stringify(setupIntentResult.data.data));

                                    if (setupIntentResult.data.meta.token) {
                                        setTimeout(() => {
                                            window.location = '/account';
                                        }, 3000);
                                    }
                                } else {
                                    this.setState({ loading: false });
                                    this.context.state.showCodeMessage('Something went wrong. Please try after refreshing the page', 'danger');
                                }
                            });
                        }
                    }
                });
            })
            .catch(error => {
				this.setState({loading: false});
                console.log(error);
                this.context.state.showCodeMessage('Something went wrong. Please try after refreshing the page', 'danger');
                // switch (error.response.status) {
                //     case 422:
                //         if(error.response.data.hasOwnProperty("errors"))
                //         {
                //             this.setState({ errors: error.response.data.errors });
                //         }
                //         else
                //         {
                //             this.setState({ errors: error.response.data.error });
                //         }

                //         break;
                //     default:
                //         this.context.state.handelError(error);
                //         break;
                // }
            });
		}
    };

    componentDidMount() {

        window.scrollTo(0, 0);

		getCheckoutStepsData({ token: "", type: 'pwonbs1' })
            .then(res => {
                if (res.status === true) {
                    console.log(res);
                    this.setState({
                        how_did_you_find_us_options: res.meta.checkout_steps_data.howDidYouHear,
                        paypal_annual_plan_id: res.meta.paypal_annual_plan_id,
                    });
                } else {
                    this.setState({ validToken: false });
                }
            })
            .catch(error => {
                this.setState({ validToken: false });
            });

    }
    paypalSubscribe = (data, actions) => {
        return actions.subscription.create({
        'plan_id': this.state.paypal_annual_plan_id,//P-9XK10853E9278530NMGYJUPY
        // 'plan_id': "P-2NJ12907YK1258046MGYMJEY",
        });
    };
    paypalOnError = (err) => {
        console.log("Error");
        console.log(err);
        this.context.state.showCodeMessage('Something went wrong. Please try again', 'danger');
    };
    payPalOnInit = (data, actions) =>{
        // const note = document.querySelector('.paypal-buttons');
        // note.style.opacity = '0.5';
        // Disable the buttons
        actions.disable();
        // Listen for changes to the checkbox
        document.querySelector('#customCheck')
          .addEventListener('change', function(event) {

            // Enable or disable the button when it is checked or unchecked
            if (event.target.checked) {
              actions.enable();
            //   const note = document.querySelector('.paypal-buttons');
            //   note.style.opacity = '';
            } else {
                // const note = document.querySelector('.paypal-buttons');
                // note.style.opacity = '0.5';
              actions.disable();
            }
          });
      };
      payPalOnClick= (data, actions) =>{
        // Show a validation error if the checkbox is not checked
        if (!document.querySelector('#customCheck').checked) {
            let error = this.state.errors;
            error['agree'] = "Please agree to our terms and conditions.";
            this.setState({errors: error });
        }
      };

    paypalOnCancel = (data) => {
          // Show a cancel page, or return to cart
    }
    paypalOnApprove = (data, detail) => {
        this.setState({ paypal_loading: true });
        // call the backend api to store transaction details
        console.log("Payapl approved")
        console.log("Data====")
        console.log(data)
        console.log("detail====")
        console.log(detail)
        console.log(data.subscriptionID)
        if(data.subscriptionID){
            let temp = this.state.item;
            temp['payment_gateway'] = 'paypal';
            temp['subscriptionID'] = data.subscriptionID;
            this.setState({ item: temp});
             /*assigning the newly created payment method to customer and create subscription */
             setCustomerSubscription(this.state).then(paypalResult => {
                console.log(paypalResult);
                if(paypalResult.status ==  200) {
                    this.context.state.showCodeMessage(paypalResult.data.message, 'success');
                    localStorage.setItem('user_steps', 'account');
                    localStorage.setItem("user", JSON.stringify(paypalResult.data.data));

                    if (paypalResult.data.meta.token) {
                        setTimeout(() => {
                            window.location = '/account';
                        }, 3000);
                    }
                } else {
                    this.setState({ loading: false });
                    this.context.state.showCodeMessage('Something went wrong. Please try after refreshing the page', 'danger');
                }
            });
        }
    };
    setPaypal=() => {
        this.setState({ is_paypal: true });
        this.setState({ showCheckoutButton: false });
    }
  render() {

    return (

        <Fragment>

            <form className="checkout-step-form" onSubmit={this.handleSubmit}>
            <div className="billing-details">
                    <div className="row mt-4">
			            {/* <div className="col-md-6">
			        	    <div className="form-group mb-4">
                                <input type="text" onChange={this.onChange} value={this.state.item.fname || ''} className="form-control" name="fname" id="fname" ref="fname" placeholder="First Name..." autoComplete="off"/>
								{this.state.errors.fname ? (
									<div className="invalid-feedback">
										{this.state.errors.fname}
									</div>
								) : null}
                            </div>
			        	</div>
			        	<div className="col-md-6">
			        	    <div className="form-group mb-4">
                                <input type="text" onChange={this.onChange} value={this.state.item.lname || ''} className="form-control" name="lname" id="lname" ref="lname" placeholder="Last Name..." autoComplete="off" />
								{this.state.errors.lname ? (
									<div className="invalid-feedback">
										{this.state.errors.lname}
									</div>
								) : null}
                            </div>
			        	</div> */}

			        	{/* <div className="col-12">
			        	    <div className="form-group mb-4">
                                <input type="text" onChange={this.onChange} value={this.state.item.address || ''} className="form-control" name="address" id="address" ref="address" placeholder="Full Address..." autoComplete="off" />
								{this.state.errors.address ? (
									<div className="invalid-feedback">
										{this.state.errors.address}
									</div>
								) : null}
                            </div>
			        	</div>
			        	<div className="col-12">
			        	    <div className="form-group mb-4">
                                <input type="text" onChange={this.onChange} value={this.state.item.city || ''} className="form-control" name="city" id="city" ref="city" placeholder="City Name..." autoComplete="off" />
								{this.state.errors.city ? (
									<div className="invalid-feedback">
										{this.state.errors.city}
									</div>
								) : null}
                            </div>
			        	</div>
						<div className="col-12">
						    <div className="form-group select mb-4">
								<CountryDropdown
									defaultOptionLabel="Select Country"
									value={this.state.item.country}
									//whitelist={["CA", "US"]}
									classes= "form-control m-input center-select"
									onChange={(val) => this.selectCountry(val)} />

								{this.state.errors.country ? (
									<div className="invalid-feedback">
										{this.state.errors.country}
									</div>
								) : null}
							</div>
			        	</div>
						<div className="col-md-6">
			        	    <div className="form-group select mb-4">

								 <RegionDropdown
								 	blankOptionLabel="State/Province..."
									//defaultOptionLabel="Select Province"
                                    defaultOptionLabel={this.state.item.province_option_label}
									classes= "form-control m-input center-select"
									country={this.state.item.country}
									value={this.state.item.province}
									onChange={(val) => this.selectRegion(val)} />
								{this.state.errors.province ? (
									<div className="invalid-feedback">
										{this.state.errors.province}
									</div>
								) : null}
							</div>
			        	</div>
			        	<div className="col-md-6">
			        	    <div className="form-group mb-4">
                                <input type="text" onChange={this.onChange} value={this.state.item.zip || ''} className="form-control" name="zip" id="zip" ref="zip" placeholder="Zip Code..." autoComplete="off" />
								{this.state.errors.zip ? (
									<div className="invalid-feedback">
										{this.state.errors.zip}
									</div>
								) : null}
                            </div>
			        	</div> */}
			        </div>
				</div>

                <h3 className="mt-4 mb-3 text-left">Payment Method</h3>

                <div className="flex-wrap flex-sm-row flex-column align-items-center justify-content-between">
                    <div className="row col-sm-auto col-12 interest-block payment-method-holder d-flex align-items-center justify-content-start">
                        <label className="payment-label mr-3">
                            <input type="radio" value="card-checkout" name="payment-method" checked={this.state.item.payment_method_details === 'card-checkout'} onChange={this.handlePaymentMethodDetailsChange}/>
                            <div className="payment-label-thumb">
                                <img width="180" height="30" src={`/images/debit.png`} alt="Credit/Debit Card" />
                            </div>
                        </label>

                        {/* {this.context.state.isAllowedGPay() &&
                            <label className="payment-label mr-lg-0 mr-3">
                                <input type="radio" value="gpay-checkout" name="payment-method" checked={this.state.item.payment_method_details === 'gpay-checkout'} onChange={this.handlePaymentMethodDetailsChange}/>
                                <div className="payment-label-thumb">
                                    <img src={`/images/gpay.png`} alt="Google Pay" width="63" height="30" />
                                </div>
                            </label>
                        } */}
                        <label className="payment-label ml-lg-3 ml-0">
                        <input type="radio" value="paypal-checkout" name="payment-method" checked={this.state.item.payment_method_details === 'paypal-checkout'} onChange={this.handlePaymentMethodDetailsChange}/>
                            <div className="payment-label-thumb">
                                <img width="180" className="paypal_img" height="30" src={`/images/paypal.png`} alt="Credit/Debit Card" />
                                {/* <button onClick={() => {this.setPaypal()}} className="paypal-button">Paypal Subscribe</button>                               */}
                            </div>
                        </label>
                    </div>
                </div>
                {/*<div className="row mt-4">
                    <div className="col-md-6">
                        <label htmlFor="fname" className="font-weight-bold"><h4>First Name</h4></label>
                        <div className="form-group mb-4">
                            <input type="text" onChange={this.onChange} value={this.state.item.fname || ''} className="form-control" name="fname" id="fname" ref="fname" placeholder="First Name..." autoComplete="off" />
                            {this.state.errors.fname ? (
                                <div className="invalid-feedback">
                                    {this.state.errors.fname}
                                </div>
                            ) : null}
                        </div>
                    </div>
                    <div className="col-md-6">
                        <label htmlFor="lname" className="font-weight-bold"><h4>Last Name</h4></label>
                        <div className="form-group mb-4">
                            <input type="text" onChange={this.onChange} value={this.state.item.lname || ''} className="form-control" name="lname" id="lname" ref="lname" placeholder="Last Name..." autoComplete="off" />
                            {this.state.errors.lname ? (
                                <div className="invalid-feedback">
                                    {this.state.errors.lname}
                                </div>
                            ) : null}
                        </div>
                    </div>
                </div>*/}
                {this.state.showCheckoutButton &&
                    <div className="row mt-4">
                        <div className="col-12">
                            <label htmlFor="card_holder" className="font-weight-bold"><h4>Cardholder's Name</h4></label>
                            <div className="form-group mb-4">
                                <input type="text" onChange={this.onChange} value={this.state.item.fname + ' ' + this.state.item.lname || ''} className="form-control" name="cardholdername" id="cardholdername" ref="cardholdername" placeholder="Cardholder's Name..." autoComplete="off" />
                                {this.state.errors.cardholdername ? (
                                    <div className="invalid-feedback">
                                        {this.state.errors.cardholdername}
                                    </div>
                                ) : null}
                            </div>
                        </div>
                    </div>
                }

                {this.state.showCheckoutButton &&
                    <div className="card-details mb-5">
                        <div className="row">
                            <div className="col-12">
                            <label htmlFor="card_details" className="font-weight-bold"><h4>Card Details</h4></label>
                                <div className="form-group cards position-relative m-0">
                                    <Card onChangeHandlerFn={this.onCardChange}/>
                                    {this.state.errors.card ? (
                                            <div className="invalid-feedback">
                                                {this.state.errors.card}
                                            </div>
                                    ) : null}
                                </div>
                            </div>
                        </div>
                    </div>
                }


				<div className="plan-details hr mb-3 pb-3">
                    <h3 className="mt-3 mb-4">Membership Total</h3>
                    <div className="row">
                        <div className="col-12">
                            <div className="d-flex align-items-center justify-content-between">
							    <h4>ProWriter Plus Membership:</h4>
							    <p>$94.00/year</p>
							</div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12">
                            <div className="d-flex align-items-center justify-content-between discount-membership">
							    <h4>First-Year Discount:</h4>
							    <p class="">(50% OFF) -$47</p>
							</div>
                        </div>
                    </div>
                </div>
                    <div className="row">
                        <div className="col-12">
                            <div className="d-flex align-items-center justify-content-between due-membership">
							    <h4>Due Today:</h4>
							    <p>$47.00</p>
							</div>
                        </div>
                    </div>
                
                <div className="membership-resp-top flex-wrap flex-sm-row flex-column align-items-center justify-content-center pt-2 mt-4 mb-2">
                        <div className="col-12 px-0 d-flex align-items-center justify-content-center">
                            <div className="incMemberShip col-12 d-flex flex-wrap align-items-center justify-content-center py-3">
                                <h3 className="text-left position-absolute">Included With Membership</h3>
                                <div className="incMemberShipItems col-12 flex-wrap d-flex align-items-center justify-content-start justify-content-xl-center text-center">
                                    <div className="incitems">
                                        <img width="109" height="93" src={`/images/jobsBoard-icon.png`} alt="Jobs Board" />
                                        <p>Jobs Board</p>
                                    </div>
                                    <div className="incitems">
                                        <img width="109" height="93" src={`/images/portfolio-icon.png`} alt="Portfolio" />
                                        <p>Portfolio</p>
                                    </div>
                                    <div className="incitems">
                                        <img width="109" height="93" src={`/images/skillCourses-icon.png`} alt="Skills Courses" />
                                        <p>Skills Courses</p>
                                    </div>
                                    <div className="incitems">
                                        <img width="109" height="93" src={`/images/private-community-icon.png`} alt="Private Community" />
                                        <p>Private Community</p>
                                    </div>
                                    <div  className="incitems">
                                        <img width="109" height="93" src={`/images/exclusiveNewsletter-icon.png`} alt="Exclusive Newsletter" />
                                        <p>Exclusive Newsletter</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                </div>
                <div className="row pt-md-5 pt-4 no-gutters">
                    <div className="col-12">
                        <div className="custom-control custom-checkbox pl-4 agree">
                            <input type="checkbox" onChange={this.handleCheckboxChange} checked={this.state.item.agree} className="custom-control-input"  name="agree" id="customCheck"/>
                            <label className="custom-control-label days font-weight-bold" htmlFor="customCheck">
                            First year $47 (50% off), then just $94/year. Cancel through your dashboard or by e-mail (<a target="_blank" href="mailto:support@prowriter.com">support@prowriter.com</a>). I also agree to the <a href="https://www.iubenda.com/privacy-policy/72278847" target="_blank">Privacy Policy</a> and <a href="https://www.iubenda.com/privacy-policy/72278847/cookie-policy" target="_blank">Cookie Policy</a>.
                            </label>
                            {this.state.errors.agree ? (
                            <div className="invalid-feedback">
                                {this.state.errors.agree}
                            </div>
                        ) : null}
                        </div>
                    </div>
                    <div className={this.props.mobileButtonVisible ? "col-12 sticky-order open mt-5 mb-4" : "col-12 mt-5 mb-4"}>
                        {this.state.showCheckoutButton && <button type="submit" disabled={this.state.loading} className={"btn btn-primary checkout-process-btn border-0 mx-auto d-block " + (this.state.isFormFilled ? "throb" : '')}> {this.state.loading ? `Processing...` : `Confirm Membership`}<i className={this.state.loading ? `mr-2 fas fa-spinner fa-spin` : `ml-2 fas fa-lock`}></i></button>}
                        {!this.state.showCheckoutButton && !this.state.is_paypal && <InjectGooglePay states={this.state} handleFormValidation={this.handleValidation}/>}
                        {this.state.is_paypal &&
                    <div className="row">
                    <div className="col-12">
                        {this.state.paypal_loading  == true ?
                        <div className="align-items-center text-center">
                        <button class="buttonload btn-lg">
                            <i class="fa fa-spinner fa-spin"></i> Processing
                        </button>
                        </div> :
                         <div className="align-items-center">
                         <PayPalBtn
                                 onInit={this.payPalOnInit}
                                 onClick={this.payPalOnClick}
                                 amount = "0.00"
                                 currency = "USD"
                                 createSubscription={this.paypalSubscribe}
                                 onApprove={this.paypalOnApprove}
                                 catchError={this.paypalOnError}
                                 onError={this.paypalOnError}
                                 onCancel={this.paypalOnCancel}
                                 />
                         </div>
                         }
                    </div>
                </div>
                }
                    </div>

                    <div id="payment-request-button">
                    </div>

                    <div className="col-12 mb-3 d-flex align-items-center justify-content-center sslImg">
                        <img width="70" height="35" src="/images/ssl-security.png" alt="ssl" className="mr-3" />
                        <img width="" height="" src="/images/stripe.png" alt="stripe" width="119" height="35" />
                    </div>

                    <div className="col-12 mb-4">
                        <small className="special text-center d-block"><u>Selected Plan</u>: ProWriter Plus <span className="font-weight-bold">50% Off First Year</span>, then just $94/year</small>
                    </div>
                </div>
                    <div className="membership-resp-bottom flex-wrap flex-sm-row flex-column align-items-center justify-content-center mt-4 mb-5">
                        <div className="col-12 px-0 d-flex align-items-center justify-content-center">
                            <div className="incMemberShip col-12 d-flex flex-wrap align-items-center justify-content-center py-3">
                                <h3 className="text-left position-absolute">Included With Membership</h3>
                                <div className="incMemberShipItems col-12 flex-wrap d-flex align-items-center justify-content-start justify-content-xl-center text-center">
                                    <div className="incitems">
                                        <img width="109" height="93" src={`/images/jobsBoard-icon.png`} alt="Jobs Board" />
                                        <p>Jobs Board</p>
                                    </div>
                                    <div className="incitems">
                                        <img width="109" height="93" src={`/images/portfolio-icon.png`} alt="Portfolio" />
                                        <p>Portfolio</p>
                                    </div>
                                    <div className="incitems">
                                        <img width="109" height="93" src={`/images/skillCourses-icon.png`} alt="Skills Courses" />
                                        <p>Skills Courses</p>
                                    </div>
                                    <div className="incitems">
                                        <img width="109" height="93" src={`/images/private-community-icon.png`} alt="Private Community" />
                                        <p>Private Community</p>
                                    </div>
                                    <div  className="incitems">
                                        <img width="109" height="93" src={`/images/exclusiveNewsletter-icon.png`} alt="Exclusive Newsletter" />
                                        <p>Exclusive Newsletter</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
            </form>
        </Fragment>

    );
  }
}
StripeCheckoutForm.contextType = AppContext;
export default function InjectedCheckoutForm() {
  return (
    <ElementsConsumer>
      {({ stripe, elements }) => (
        <StripeCheckoutForm stripe={stripe} elements={elements} />
      )}
    </ElementsConsumer>
  );
}



// WEBPACK FOOTER //
// ./src/components/general/include/StripeCheckoutForm.js